<template>
  <div>
    <div v-for="(condition, idx) in conditions" :key="condition.id" class="condition">
      <div class="body">
        <div class="float-right">
          <a
            :class="defaultButtonClasses.concat(['btn-primary'])"
            href="#"
            @click.prevent="addCondition(conditions, idx)"
          >
            <span class="fa fa-plus"/>
            <span class="sr-only">Add Condition</span>
          </a>
          <a
            v-if="conditions.length > 1 || condition.type!=''"
            :class="defaultButtonClasses.concat(['btn-danger'])"
            href="#"
            @click.prevent="removeItem(conditions, idx)"
          >
            <span class="fa fa-trash"/>
            <span class="sr-only">Delete Condition</span>
          </a>
        </div>
        <select v-model="condition.type" class="form-control" @change="feedback.updateConditionProps(condition)">
          <option value="">
            Select condition
          </option>
          <option v-for="(label, value) in config.conditionTypes" :value="value">
            {{ label }}
          </option>
        </select>
        <component :is="condition.type" v-bind.sync="condition" :config="config" />
      </div>
      <div v-if="idx < conditions.length - 1" class="separator">
        {{ separator }}
      </div>
    </div>
  </div>
</template>
<script>
  import { v4 as uuidV4 } from 'uuid';

  // Conditions
  import Completion from './conditions/Completion.vue';
  import EventCompletionLookback from './conditions/EventCompletionLookback.vue';
  import EventComplianceLookback from './conditions/EventComplianceLookback.vue';
  import IfBlockFormField from './conditions/IfBlockFormField.vue';
  import IfFormField from './conditions/IfFormField.vue';
  import IfTeamRep from './conditions/IfTeamRep.vue';
  import IfVariable from './conditions/IfVariable.vue';
  import IfParticipantLanguage from './conditions/IfParticipantLanguage.vue';
  import IfMissingProfileFields from './conditions/IfMissingProfileFields.vue';
  import IfSourceLastDatum from './conditions/IfSourceLastDatum.vue';
  import PartnerEventCompletionLookback from './conditions/PartnerEventCompletionLookback.vue';
  import PartnerEventComplianceLookback from './conditions/PartnerEventComplianceLookback.vue';
  import SurveyLookback from './conditions/SurveyLookback.vue';
  import AdherenceCategory from './conditions/AdherenceCategory.vue';
  import AdherenceCategoryLookback from './conditions/AdherenceCategoryLookback.vue';
  import IfPhoneNumber from './conditions/IfPhoneNumber.vue';
  import IfStudyGroup from './conditions/IfStudyGroup.vue';

  export default {
    components: {
      Completion,
      EventCompletionLookback,
      EventComplianceLookback,
      IfBlockFormField,
      IfFormField,
      IfTeamRep,
      IfVariable,
      IfParticipantLanguage,
      IfMissingProfileFields,
      IfSourceLastDatum,
      PartnerEventCompletionLookback,
      PartnerEventComplianceLookback,
      SurveyLookback,
      AdherenceCategory,
      AdherenceCategoryLookback,
      IfPhoneNumber,
      IfStudyGroup,
    },
    props: {
      conditions: {
        type: Array,
        default: () => []
      },
      config: Object,
      defaultButtonClasses: Array,
      separator: String,
      feedback: {
        type: Object, // should really be type: Feedback but that causes an import dependency cycle
      },
    },
    methods: {
      // TODO: this is a duplicate of what's in BaseApp
      addCondition: function(list, after) {
        list.splice(after + 1, 0, { id: uuidV4(), type: '' });
      },
      removeItem: function (list, idx) {
        list.splice(idx, 1);
      },
      validate: function () {
        var valid = true;
        this.$children.forEach(function (component) {
          if (component.hasOwnProperty('validate')) {
            valid = component.validate() && valid;
          }
        });
        return valid;
      },
    },
  }
</script>
